import React, { useContext } from "react";
import * as styles from "./Navi.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import { useLocation, useNavigate } from "react-router-dom";
import { SaveInspectionContext } from "@app/components/SaveInspectionContextContainer/SaveInspectionContextContainer.jsx";
import Button from "@app/components/Button";

const Navi = ({ items, title, meta, show = true, onClickClose }) => {
	const naviClassName = classNames({
		[styles["navi"]]: true,
		["open"]: !!show,
	});

	const { pathname } = useLocation();
	let counter = 0;
	const { saveInspectionHandler } = useContext(SaveInspectionContext);
	const navigate = useNavigate();

	return (
		<div className={naviClassName}>
			<CSSTransition in={show} timeout={300} classNames={"navi-fade"} mountOnEnter={true} unmountOnExit={true}>
				<div className={styles["navi-background"]} onClick={onClickClose} />
			</CSSTransition>
			<CSSTransition in={show} timeout={300} classNames={"navi-slide"} mountOnEnter={true} unmountOnExit={true}>
				<div className={styles["navi-inner"]}>
					<div className={styles["navi-title"]}>
						<div className={styles["close-button"]} onClick={onClickClose} />
						{title}
					</div>
					<ul>
						{items &&
							items.map(
								(
									{ label, enabled = true, active, isOverview = false, noCounter = false, ...item },
									index,
								) => {
									let itemClassName = classNames({
										[styles.active]: !!active || item.to === pathname,
										[styles.enable]: !!enabled,
										[styles.overview]: !!isOverview,
									});

									if (!noCounter) counter = counter + 1;

									return (
										<li className={itemClassName} key={index}>
											{enabled ? (
												<span
													{...item}
													onClick={async (event) => {
														await item.onClick?.(event);
														if (!item.preventDefault) {
															if (!isOverview && saveInspectionHandler?.active) {
																await saveInspectionHandler?.fn?.(item.to);
															} else {
																navigate(item.to);
															}
														}
														onClickClose();
													}}
												>
													{!noCounter && <span>{counter}.</span>}
													{label}
												</span>
											) : (
												<span>{label}</span>
											)}
										</li>
									);
								},
							)}
					</ul>
					<div className={styles["navi-meta"]}>
						{meta &&
							meta.map((item, index) => {
								switch (item.type) {
									case "primary-button":
										return (
											<Button
												key={index}
												href={item.href}
												callback={item.onClick}
												label={item.label}
												iconBefore={item.icon}
												className={styles["meta-button"]}
											/>
										);
									default:
										return (
											<a
												className={styles["meta-item"]}
												href={item.href}
												key={index}
												onClick={async (event) => {
													await item.onClick?.(event);
													if (!item.preventDefault) {
														if (!isOverview && saveInspectionHandler?.active) {
															await saveInspectionHandler?.fn?.(item.to);
														} else {
															navigate(item.to);
														}
													}
													onClickClose();
												}}
											>
												{item.icon}
												<div dangerouslySetInnerHTML={{ __html: item.label }} />
											</a>
										);
								}
							})}
					</div>
				</div>
			</CSSTransition>
		</div>
	);
};

Navi.propTypes = {
	title: PropTypes.string,
	show: PropTypes.bool,
	meta: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.node,
			label: PropTypes.string,
			href: PropTypes.string,
		}),
	),
	items: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			onClick: PropTypes.func,
			active: PropTypes.bool,
			enable: PropTypes.bool,
		}),
	),
	onClickItem: PropTypes.func,
	onClickClose: PropTypes.func,
};

export default Navi;
